import classNames from 'classnames';
import type { CSSProperties, PropsWithChildren } from 'react';
import styled, { keyframes } from 'styled-components';

import type { Color } from '#src/style/types.ts';

const scaleInAnimation = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.5);
   }
   50% {
    opacity: 1;
    transform: scale(1.1);
   }
   100% {
    opacity: 1;
    transform: scale(1);
   }
`;
const Root = styled.div`
  --border-width: 1px;
  --corner-size: 20px;
  --corner-color: var(--c-black);

  border: var(--border-width) solid var(--corner-color);
  mask:
    conic-gradient(at var(--corner-size) var(--corner-size), #0000 75%, #000 0)
      0 0 / calc(100% - var(--corner-size)) calc(100% - var(--corner-size)),
    linear-gradient(#000 0 0) content-box;

  &.scaleIn {
    transform: scale(0.5);
    opacity: 0;
    animation: 1s ${scaleInAnimation} var(--delay) ease-in-out forwards;
  }
`;

type Props = {
  className?: string;
  scaleIn?: boolean;
  borderWidth?: number;
  cornerColor: Color | `rgba(${number}, ${number}, ${number}, ${number})`;
  cornerSize: number;
  delay?: number;
};
export const CornerBorderedBox = ({
  className,
  scaleIn,
  borderWidth,
  cornerColor,
  cornerSize,
  delay = 0,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <Root
      className={classNames(className, { scaleIn: !!scaleIn })}
      style={
        {
          '--corner-size': `${cornerSize}px`,
          '--corner-color': cornerColor,
          '--border-width': `${borderWidth}px`,
          '--delay': `${delay}ms`,
        } as CSSProperties
      }
    >
      {children}
    </Root>
  );
};
